import React from 'react'
import styled from 'styled-components'

export const Subtitle = styled.div`
  margin-bottom: 30px;
  font-weight: 100;
`
